import React from 'react';
import PropTypes from 'prop-types';
import { isArray } from 'underscore';
import { Card, CardBody, CardHeader, Button, Row, Col } from 'reactstrap';
import Icon from '../../common/containers/icon';
import SearchInput from '../../common/search/searchInput';
import StatusFilter from './statusFilter';
import JobsFilter from './jobsFilter';
import entityComposition from '../../common/classes/entityComposition';
class EmployeesFilters extends React.Component {
  constructor(props) {
    super(props);
    this.handleFilter = this.handleFilter.bind(this);
    this.handleFilterClear = this.handleFilterClear.bind(this);
    this.handleSearch = text => this.handleFilter('text', text);
    this.handleSearchClear = () => this.handleFilter('text', '');
    this.handleFilter('status', '1');
  }
  handleFilter(prop, value) {
    const _this$props = this.props,
      employee = _this$props.employee,
      employeeActions = _this$props.employeeActions;
    const newFilters = JSON.parse(JSON.stringify(employee.indexQuery.filters));
    if (value !== null) {
      newFilters[prop] = value;
    } else {
      delete newFilters[prop];
    }
    employeeActions.serverFilter(newFilters, employee.indexQuery);
  }
  handleFilterClear() {
    const _this$props2 = this.props,
      employeeActions = _this$props2.employeeActions,
      employee = _this$props2.employee;
    employeeActions.serverFilter(employee.initialIndexQuery.filters, employee.initialIndexQuery);
  }
  render() {
    const _this$props$employee$ = this.props.employee.indexQuery.filters,
      _this$props$employee$2 = _this$props$employee$.job,
      job = _this$props$employee$2 === void 0 ? [] : _this$props$employee$2,
      _this$props$employee$3 = _this$props$employee$.text,
      text = _this$props$employee$3 === void 0 ? '' : _this$props$employee$3,
      _this$props$employee$4 = _this$props$employee$.status,
      status = _this$props$employee$4 === void 0 ? '' : _this$props$employee$4;
    let jobs = [];
    if (job) {
      jobs = isArray(job) ? job : [job];
    }
    return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      xs: 8
    }, /*#__PURE__*/React.createElement("h3", null, "Filter")), /*#__PURE__*/React.createElement(Col, {
      xs: 4
    }, /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.handleFilterClear,
      className: "float-md-right t-ec-filter-clear"
    }, /*#__PURE__*/React.createElement(Icon, {
      glyph: "times-circle",
      weight: "far"
    }), " Clear")))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(SearchInput, {
      type: "text",
      text: text,
      onChange: this.handleSearch,
      onClear: this.handleSearchClear
    }), /*#__PURE__*/React.createElement(StatusFilter, {
      status: status,
      onFilter: this.handleFilter
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: '10px'
      }
    }, /*#__PURE__*/React.createElement(JobsFilter, {
      jobs: jobs,
      onFilter: this.handleFilter
    }))));
  }
}
EmployeesFilters.propTypes = {
  employee: PropTypes.shape({
    indexQuery: PropTypes.shape({
      filters: PropTypes.shape({
        job: PropTypes.arrayOf(PropTypes.shape({})),
        status: PropTypes.string,
        text: PropTypes.string
      }).isRequired
    }),
    initialIndexQuery: PropTypes.shape({
      filters: PropTypes.shape({})
    })
  }).isRequired,
  employeeActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired
};
export { EmployeesFilters as TestEmployeesFilters };
export default entityComposition(EmployeesFilters, ['employee']);